import { api } from "./client";
import type { LoginRequest, LoginResponse, User } from "./types";

const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:4000";

export const authService = {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || "Erro ao fazer login");
    }

    const data: LoginResponse = await response.json();

    // Store tokens
    localStorage.setItem("accessToken", data.accessToken);
    localStorage.setItem("refreshToken", data.refreshToken);

    return data;
  },

  async logout(): Promise<void> {
    const refreshToken = localStorage.getItem("refreshToken");

    if (refreshToken) {
      try {
        await fetch(`${API_URL}/auth/logout`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refreshToken }),
        });
      } catch {
        // Ignore errors on logout
      }
    }

    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  },

  async getMe(): Promise<User> {
    return api.get<User>("/auth/me");
  },

  async register(data: {
    email: string;
    password: string;
    name: string;
    role?: "ADMIN" | "DOCTOR" | "RECEPTIONIST";
  }): Promise<{ message: string; user: User }> {
    return api.post("/auth/register", data);
  },

  isAuthenticated(): boolean {
    if (typeof window === "undefined") return false;
    return !!localStorage.getItem("accessToken");
  },
};
